import { useMutation } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';

export const useCreateOnsiteInterviews = () => {
  const mutation = useMutation({
    mutationFn: async (payload) => PermanentJobsService.createOnsiteInterviews(payload),
  });

  return mutation;
};
